__turbopack_context__.v({
  "video-modal__body": "VideoModal-module-scss-module__JFIpsq__video-modal__body",
  "video-modal__empty": "VideoModal-module-scss-module__JFIpsq__video-modal__empty",
  "video-modal__player": "VideoModal-module-scss-module__JFIpsq__video-modal__player",
  "video-modal__video": "VideoModal-module-scss-module__JFIpsq__video-modal__video",
});
